import { render, staticRenderFns } from "./ListaCompra.vue?vue&type=template&id=46852a11"
import script from "./ListaCompra.vue?vue&type=script&lang=js"
export * from "./ListaCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports